import React, { useState, useEffect } from "react"
import { ChevronRight, FavoriteBorderOutlined, Inventory, LocalActivityOutlined, Logout, MailOutline, RateReviewOutlined, UpdateOutlined, YoutubeSearchedForOutlined } from "@mui/icons-material"
import { useNavigate } from "react-router-dom"
import { Badge, Modal } from "@mui/material"
import { useSelector } from "react-redux"
import Universalpageheader from "../Headers/universalpageheader"
import Searchbar from "../Components/searchbar"
import SignIn from "../Common/login"
const { primarycolor } = require("../Utils/colors")

const Account = ({ onrefresh, onlogout, oncloseaccount }) => {
    const { user, loggedIn } = useSelector((state) => state.user);
    const favorites = useSelector(state => state.favorites.data);
    const recentlyViewed = useSelector((state) => state.recentlyViewed.data);
    const webSettings = useSelector((state) => state.webSettings.data);
    const subProducts = useSelector((state) => state.subProducts.data);


    const fullName = webSettings.FULL_NAME;
    const sitename = fullName?.split(' ')[0];


    const navigate = useNavigate()
    const [cart, setcart] = useState(0);

    const [showlogin, setshowlogin] = useState(false);
    const [showsearchbar, setshowsearchbar] = useState(false);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);


    const onsuccesslogin = () => {
        setshowlogin(false)
    }

    return (
        <div>
            {showlogin && <SignIn ondismiss={() => setshowlogin(false)} onsuccesslogin={onsuccesslogin} />}
            {showsearchbar && <Searchbar dismissmodals={() => setshowsearchbar(false)} products={subProducts?.flatMap((obj) => obj.items)} />}
            <Universalpageheader pagename={"Account"} onshowsearch={() => setshowsearchbar(true)} withemail={true} /><br />
            <div>
                <div style={{
                    width: "95%",
                    margin: "auto"
                }}>
                    {loggedIn && <div className="useremail">{user?.fullName}</div>}
                    <div className="menusectiontitle">MY ACCOUNT</div>
                    <div className="walletbuttons" onClick={() => loggedIn ? navigate("/orders") : setshowlogin(true)} >
                        <div className="walletbuttonsleft">
                            <div className="walleticondiv">
                                <Inventory />
                            </div>
                            <div className="menubuttontext">&nbsp;Orders</div>
                        </div>
                        <ChevronRight color={primarycolor} />
                    </div>
                    <div className="walletbuttons" >
                        <div className="walletbuttonsleft">
                            <div className="walleticondiv">
                                <MailOutline />
                            </div>
                            <div className="menubuttontext">&nbsp;Inbox</div>
                        </div>
                        <ChevronRight />
                    </div>
                    <div className="walletbuttons" >
                        <div className="walletbuttonsleft">
                            <div className="walleticondiv">
                                <RateReviewOutlined />
                            </div>
                            <div className="menubuttontext">&nbsp;Pending Reviews</div>
                        </div>
                        <ChevronRight color={primarycolor} />
                    </div>
                    <div className="walletbuttons" >
                        <div className="walletbuttonsleft">
                            <div className="walleticondiv">
                                <Badge badgeContent={cart} color="success" >
                                    <LocalActivityOutlined />
                                </Badge>
                            </div>
                            <div className="menubuttontext">&nbsp;Vouchers</div>
                        </div>
                        <ChevronRight color={primarycolor} />
                    </div>
                    <div className="walletbuttons" onClick={() => navigate("/saveditems")}>
                        <div className="walletbuttonsleft">
                            <div className="walleticondiv">
                                {favorites?.length > 0 ?
                                    <Badge badgeContent={favorites?.length} color="primary">
                                        <FavoriteBorderOutlined />
                                    </Badge> :
                                    <FavoriteBorderOutlined />
                                }
                            </div>
                            <div className="menubuttontext">&nbsp;Saved Items</div>
                        </div>
                        <ChevronRight />
                    </div>
                    <div className="walletbuttons" onClick={() => navigate("/recents")}>
                        <div className="walletbuttonsleft">
                            <div className="walleticondiv">
                                <UpdateOutlined />
                            </div>
                            <div className="menubuttontext">&nbsp;Recently Viewed</div>
                        </div>
                        <ChevronRight />
                    </div>
                    <div className="walletbuttons" onClick={() => navigate("/lastsearched")}>
                        <div className="walletbuttonsleft">
                            <div className="walleticondiv">
                                <YoutubeSearchedForOutlined />
                            </div>
                            <div className="menubuttontext">&nbsp;Recently Searched</div>
                        </div>
                        <ChevronRight />
                    </div>


                    <div className="menusectiontitle">MY SETTINGS</div>
                    <div className="walletbuttons" onClick={() => loggedIn ? navigate("/profilesettings") : setshowlogin(true)}>
                        <div className="walletbuttonsleft">
                            <div className="menubuttontext">&nbsp;Account Management</div>
                        </div>
                        <ChevronRight />
                    </div>
                    {loggedIn &&
                        <>
                            <div className="walletbuttons" onClick={() => oncloseaccount()}>
                                <div className="walletbuttonsleft">
                                    <div className="menubuttontext">&nbsp;Close Account</div>
                                </div>
                                <ChevronRight />
                            </div>
                            <div className="walletbuttons" onClick={() => onlogout()}>
                                <div className="walletbuttonsleft">
                                    <div className="walleticondiv">
                                        <Logout />
                                    </div>
                                    <div className="menubuttontext">&nbsp;Logout</div>
                                </div>
                                <ChevronRight />
                            </div>
                        </>}
                </div>

            </div>
        </div >
    )
}

export default Account